export default [
    {
        path: '/auth/reset-password',
        name: 'forgot-password',
        component: () => import('@/views/forgotPassword/index.vue'),
        meta: {
            layout: 'full',
        },
    },
]